import { Pipe, PipeTransform } from '@angular/core';
import { CardModel, PartModel } from 'src/app/models';

@Pipe({ name: 'toPartCards' })
export class PartCardsPipe implements PipeTransform {
  transform(values: PartModel[]): CardModel[] {
    return values?.map((p) => CardModel.fromPartModel(p));
  }
}
